import { Navigate, Outlet, useLocation } from "react-router";

import { Skeleton } from "../../components/Skeleton";
import { nl } from "../../i18n/nl";
import { useMe } from "./session";

export const NEXT_PARAM = "volgende";
const ONBOARDING_PATH = "/welkom";

/** Only for logged-in students. Logged out: `/` shows the launch page, deep links go to login. */
export function RequireAuth() {
  const me = useMe();
  const location = useLocation();

  if (me.isPending) {
    return (
      <div role="status" aria-busy="true" aria-label={nl.common.loading} style={{ padding: 24 }}>
        <Skeleton width="40%" height={22} />
      </div>
    );
  }
  if (me.data) {
    // No profile yet: onboarding first (docs/PRODUCT.md § Profielen), then back to where you were.
    if (me.data.profiles.length === 0 && location.pathname !== ONBOARDING_PATH) {
      const next = encodeURIComponent(location.pathname + location.search);
      return <Navigate to={`${ONBOARDING_PATH}?${NEXT_PARAM}=${next}`} replace />;
    }
    return <Outlet />;
  }
  if (location.pathname === "/") return <Navigate to="/over" replace />;
  const next = encodeURIComponent(location.pathname + location.search);
  return <Navigate to={`/inloggen?${NEXT_PARAM}=${next}`} replace />;
}

/** Only relative in-app paths are followed after login (no open redirects). */
export function safeNext(value: string | null): string {
  if (!value || !value.startsWith("/") || value.startsWith("//")) return "/";
  return value;
}
